import authService from './auth.service';

const handle_error = (error) => {
  if (window.appInsights) {
    window.appInsights.trackTrace({ message: error.message });
  } else {
    // there is no appInsights object to write the trace to.
  }
  throw error;
};

const get = async (url, additional_headers) => {
  url = url.includes('#') ? url.replace(/#/g, encodeURIComponent('#')) : url;
  const headers = await authService.getIdTokenHeaders(additional_headers);
  return fetch(url, { method: 'GET', headers }).catch(handle_error);
};

const post = async (url, request, additional_headers, additionalFetchParameters) => {
  url = url.includes('#') ? url.replace(/#/g, encodeURIComponent('#')) : url;
  const body = JSON.stringify(request);
  const headers = await authService.getIdTokenHeaders(additional_headers);
  return  fetch(url, { method: 'POST', body, headers, ...additionalFetchParameters}).catch(handle_error);
};

const putBinary = async (url, blob, additional_headers) => {
  const headers = await authService.getIdTokenHeadersForFileUpload(additional_headers);
  return fetch(url, { method: 'PUT', body: blob, headers }).catch(handle_error);
};

const postFileUpload = async (url, file, additional_headers) => {
  const headers = await authService.getIdTokenHeadersForFileUpload(additional_headers, false);
  return fetch(url, { method: 'POST', body: file, headers }).catch(handle_error);
};

const patch = async (url, request, additional_headers) => {
  const body = JSON.stringify(request);
  const headers = await authService.getIdTokenHeaders(additional_headers);
  return fetch(url, { method: 'PATCH', body, headers }).catch(handle_error);
};

const del = async (url, request, additional_headers) => {
  const body = JSON.stringify(request);
  const headers = await authService.getIdTokenHeaders(additional_headers);
  return fetch(url, { method: 'DELETE', body, headers }).catch(handle_error);
};

const put = async(url, request, additional_headers) => {
  const body = JSON.stringify(request);
  const headers = await authService.getIdTokenHeaders(additional_headers);
  return fetch(url, { method: 'PUT', body, headers }).catch(handle_error);
}

export { get, post, putBinary, patch, del, postFileUpload, put};
